export default __webpack_public_path__ + "static/media/trylleby-property-14.04627645.jpg";